import { render, staticRenderFns } from "./ProposalFilter.vue?vue&type=template&id=2f3f34ac"
import script from "./ProposalFilter.vue?vue&type=script&lang=js"
export * from "./ProposalFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports